// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2oWzS","filesListContainer":"PosDisputesFiles_filesListContainer__1V9pu","filesButton":"PosDisputesFiles_filesButton__31-nC"};